<template>
  <div class="container">
    <div class="features">
      <slot></slot>
    </div>
    <div class="mockup-container" :class="{ 'is-fixed': fixed }" :style="{ top: position }">
      <mobile-mockup>
        <img v-for="(feature, index) in features" v-show="currentIndex === index" :src="feature.screenshootSrc" alt="">
      </mobile-mockup>
    </div>
  </div>
</template>

<script>
import MobileMockup from './MobileMockup'

export default {
  name: 'mobile-demo',
  data () {
    return {
      features: [],
      currentIndex: 0,
      fixed: true,
      position: '50%'
    }
  },
  mounted () {
    this.features = this.$children.filter(comp => comp.$options.name === 'mobile-demo-feature')
    this.features.forEach((feature, index) => {
      feature.index = index
    })

    this.onScroll()

    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll: function () {
      const el = this.features[this.currentIndex].$el

      const height = el.offsetHeight
      const scrollTop = -el.getBoundingClientRect().top

      this.fixed = true
      this.position = '50%'

      // Keep phone inside his content
      if (this.currentIndex === 0 && scrollTop <= 0) {
        this.fixed = false
        this.position = (height / 2) + 'px'
      } else if (this.currentIndex === this.features.length - 1 && scrollTop >= 0) {
        this.fixed = false
        this.position = (height * this.features.length) - (height / 2) + 'px'
      }

      // Detect feature change
      if (this.currentIndex > 0 && scrollTop < -height / 2) {
        this.currentIndex--
      } else if (this.currentIndex < this.features.length - 1 && scrollTop > height / 2) {
        this.currentIndex++
      }
    }
  },
  computed: {
    currentScreenshoot: function () {
      if (this.features[this.currentIndex]) {
        return this.features[this.currentIndex].$props.screenshootSrc
      } else {
        return ''
      }
    }
  },
  components: {
    MobileMockup
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/_variables.scss';

.mockup-container {
  width: 155px;
  position: absolute;
  // left: 1.5rem;
  top: 50%;
  transform: translateX(0%) translateY(-50%);
  /*position: absolute;*/
  /*width: 304px;*/
  /*left: 28%;*/
  /*transform: translateY(-50%);*/
  /*top: 5800px;*/
  /*top: 3942px;*/
}

.mockup-container.is-fixed {
  position: fixed;
  /*top: 50%;*/
}

.screenshoot {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

@media screen and (min-width: $tablet) {
  .mockup-container {
    width: 304px;
    left: calc(50% - 304px / 2);
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// MobileDemo.vue?3797cb3e